<script>
export default {
  methods: {
    fillInAddress() {
      const place = {
        address_components: [],
        ...this.autocompleteInstance.getPlace(),
      };

      let addressValue = '';
      const mapping = {
        street_number: 'street_number',
        route: 'user_address',
        locality: 'user_city',
        postal_code: 'zip',
        administrative_area_level_1: 'user_state',
      };

      // reset fields
      Object.keys(mapping).forEach((type) => {
        if (this.fields[mapping[type]] === 'user_state') {
          this.fields[mapping[type]] = {};
        } else {
          this.fields[mapping[type]] = '';
        }
      });

      place.address_components.forEach((component) => {
        component.types.forEach((type) => {
          if (mapping[type]) {
            if (mapping[type] === 'user_state') {
              const state = this.statesList.find(s => s.name === component.long_name);
              const currentState = {
                id: state.id,
                slug: state.code,
                name: state.name,
              };
              this.fields[mapping[type]] = currentState;
            } else if (mapping[type] === 'street_number') {
              addressValue = `${component.long_name} ${addressValue}`;
            } else if (mapping[type] === 'user_address') {
              addressValue = `${addressValue} ${component.long_name}`;
              this.fields[mapping[type]] = addressValue;
            } else {
              this.fields[mapping[type]] = component.long_name;
            }
            this.addressPopulated = true;
          }
        });
      });
    },
  },
};
</script>
